import { Observable } from 'rxjs';

export interface DeliveryLocation 
{
    id,
    name
}

export interface CompanyData
{
    id,
    name,
    deliveryLocations: DeliveryLocation[]
}

export abstract class CompaniesData {
    abstract getAllCompaniesData(): Observable<CompanyData[]>;
    abstract getAllDeliveryLocationsData(): Observable<DeliveryLocation[]>;
}